<div class="dialog-container">
    <p-table #tableMandators [value]="mandators" dataKey="id" selectionMode="single" [(selection)]="selectedMandator" [metaKeySelection]="false" [scrollable]="true" scrollHeight="400px"
        [globalFilterFields]="['code', 'codeInternal', 'description']"
        sortField="code" [sortOrder]="1">
        <ng-template pTemplate="header">
            <tr class="table-header">
                <th style="flex: 25%" pSortableColumn="code">Code <p-sortIcon field="code"></p-sortIcon></th>
                <th style="flex: 25%" pSortableColumn="codeInternal">Code Internal <p-sortIcon field="codeInternal"></p-sortIcon></th>
                <th style="flex: 50%" pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-mandator>
            <tr [pSelectableRow]="mandator" [ngClass]="((selectedMandator === mandator) ? 'table-data-row-selected' : 'table-data-row')" (click)="onSelectMandator(mandator)">
                <td style="flex: 25%">{{mandator?.code}}</td>
                <td style="flex: 25%">{{mandator?.codeInternal}}</td>
                <td style="flex: 50%">{{mandator?.description}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div style="text-align: right; margin-top: 10px;">
    <p-button icon="fa fa-times" label="Cancel" styleClass="p-button-text p-button-danger p-button-lg" (onClick)="cancelAsync()"></p-button>
    <p-button icon="fa fa-check" label="OK" styleClass="p-button-text p-button-success p-button-lg" [disabled]="(canSubmit === false)" (onClick)="submitAsync()"></p-button>
</div>
